export default [
  {
    path: 'advanced-revision',
    name: 'advancedRevision',
    redirect: 'advanced-revision/index',
    component: () =>
      import(
        /* webpackChunkName: "advancedRevision" */ '../views/advancedRevision/AdvancedRevision.vue'
      ),
    children: [
      {
        path: 'index',
        name: 'advancedRevisionIndex',
        meta: {
          tabbable: true,
          tableKeys: ['advancedRevision'],
          filterKeys: ['advancedRevision'],
          formKeys: [],
          // routePermissions: ['advancedRevision'],
        },
        component: () =>
          import(
            /* webpackChunkName: "advancedRevisionIndex" */ '../views/advancedRevision/AdvancedRevisionIndex.vue'
          ),
      },
    ],
  },
];
